export enum NewsAuthorizationStatusEnum {
  AUTHORIZATION_PENDING = 'Autorização pendente',
  AUTHORIZED = 'Autorizado',
  NOT_AUTHORIZED = 'Não autorizado',
  VISUALIZED = 'Visualizado',
  NOT_VISUALIZED = 'Não visualizado',
}
